var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "flat": ""
    }
  }, [_c('v-responsive', {
    ref: "container",
    attrs: {
      "aspect-ratio": 4 / 3,
      "content-class": "grey lighten-5"
    }
  }, [_c('video', {
    ref: "video",
    staticClass: "mb-n8",
    attrs: {
      "autoplay": "",
      "playsinline": ""
    },
    domProps: {
      "srcObject": _vm.stream_canvas
    }
  })]), _vm.stream_media ? _c('v-overlay', {
    attrs: {
      "absolute": ""
    }
  }, [_c('canvas', _vm._b({
    ref: "canvas",
    staticClass: "mb-n8"
  }, 'canvas', {
    width: _vm.width,
    height: _vm.height
  }, false))]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }